export default __webpack_public_path__ + "static/media/modelo-blanco.3984b7bd.svg";